<!--
     <ActionTransitions
       size='small'
       :unit="QUnit"
       :loading
       @transition="action_transition(transition_obj)"
     />
-->

<template>
  <v-progress-circular
    v-if="loading"
    indeterminate
    :color="color"
    :size="size == 'small' ? 20 : 30"
  />
  <v-menu
  v-else-if="show_action"
    top
    offset-y
    content-class="qmkey-explorer-table-menu-contents"
    :disabled="disabled"
  >
    <template v-slot:activator="{ attrs, on }">
      <div>
        <v-icon
          :small="size == 'small'"
          :large="size == 'large'"
          v-on="on"
          v-bind="attrs"  
          :color="color"
          @click="click"
          :disabled="disabled"
        >
          mdi-pencil
        </v-icon>
      </div>
    </template>
    <v-list dense>
      <v-list-item
        v-for="transition in unit.transition_candidates"
        :key="transition.id"
        @click.stop="action_transition(transition)"
      >
        <v-list-item-title>{{ transition.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>


<script>
 export default {
   name: "ActionTransitions",

   props: {
     size: {default: 'small'},
     unit: {required: true},
     loading: {type: Boolean, default: false},
     disabled: Boolean,
     color: {},
     disabled: Boolean
   },

   computed: {
      show_action() {
        return (this.unit.transition_candidates || []).length > 0;
      },
   },

   methods: {
     action_transition(trans_obj) {
       this.$emit('transition', trans_obj);
     },
     click() {
      this.$emit('clicked');
     },
   },
 };
</script>
